import React from 'react';
import {useTranslation} from 'react-i18next';
import {Router, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';
import PhoneVerificationProvider from '../_components/PhoneVerification/PhoneVerificationProvider';

import {history} from '../_helpers';
import {alertActions} from '../_actions';
import {ThemeProvider} from '@material-ui/styles';
import theme from '../theme';
import Routes from '../Routes';
import {SnackbarProvider} from 'notistack';
import Alert from './Alert';
import Auth from '../_HOC/Auth';
import Language from '../_HOC/Language';
import axInst from '../_helpers/axios-instance';

// import {useServiceWorker} from '../hooks/useServiceWorker';

function ScrollToTop() {
  const {pathname} = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App(props) {
  const {alert, clearAlerts, userSelectedData} = props;
  // const {needsUpdate} = useServiceWorker();
  const {t} = useTranslation();

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }

  React.useEffect(() => {
    const unlisten = history.listen((location, action) => {
      clearAlerts();
    });

    return () => {
      unlisten();
    };
  }, [clearAlerts]);

  const [alertWarehouse, setAlertWarehouse] = React.useState(false);
  const [responseWarehouse, setResponseWarehouse] = React.useState(null);

  const ALLOWED_TIMES = [
    { h: 9, m: 0 },
    { h: 13, m: 30 },
    { h: 17, m: 0 },
  ];

  const formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
  };

  const sendRequest = () => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 2);

    const endDateFormatted = formatDate(endDate);
    const startDateFormatted = formatDate(startDate);

    axInst.post('/api/get-statistics-orders-warehouseman/', {
      customer_id: userSelectedData.customer_id,
      filter_start_date: startDateFormatted,
      filter_end_date: endDateFormatted,
    })
      .then(response => {
        setAlertWarehouse(true);
        setResponseWarehouse(response?.data?.new);

        setTimeout(() => {
          setAlertWarehouse(false);
          setResponseWarehouse(null);
        }, 5 * 60 * 1000);
      })
      .catch(error => {
        console.error('error', error);
      });
  };

  const lastRunRef = React.useRef(null);

  React.useEffect(() => {
    const checkTimeAndSend = () => {
      const now = new Date();
      const h = now.getHours();
      const m = now.getMinutes();

      const isAllowedTime = ALLOWED_TIMES.some(
        t => t.h === h && t.m === m
      );

      const currentKey = `${h}:${m}`;

      if (isAllowedTime && lastRunRef.current !== currentKey) {
        lastRunRef.current = currentKey;
        sendRequest();
      }
    };

    checkTimeAndSend();

    const interval = setInterval(checkTimeAndSend, 60 * 1000);

    return () => clearInterval(interval);
  }, []);


  return (
    <SnackbarProvider maxSnack={3}>
      {/* {needsUpdate && (
        <Alert
          alert={{
            message: `${t('common:update_version')}`,
            variant: 'error',
            autoHideDuration: 999999,
          }}
        />
      )} */}
      {alert && <Alert alert={alert} />}

      {alertWarehouse && responseWarehouse?.[2] && (<Alert alert={{
        message: `У вас є необроблені замовлення у комірнику. (${responseWarehouse?.[2]} шт.)`,
        variant: 'warning',
        autoHideDuration: 99999,
      }} />)}
      <ThemeProvider theme={theme}>
        <PhoneVerificationProvider>
          <Router history={history}>
            <ScrollToTop />
            <Auth />
            <Language />
            <Routes />
          </Router>
        </PhoneVerificationProvider>
      </ThemeProvider>
    </SnackbarProvider>
  );
}

function mapState(state) {
  const {alert, userSelectedData} = state;
  return {alert, userSelectedData};
}

const actionCreators = {
  clearAlerts: alertActions.clear,
};

const connectedApp = connect(mapState, actionCreators)(App);
export {connectedApp as App};
